export default __webpack_public_path__ + "static/media/ai-cid-icon.2cadc345.svg";